import { render, staticRenderFns } from "./TermsDetail.vue?vue&type=template&id=3dafb051&"
import script from "./TermsDetail.vue?vue&type=script&lang=js&"
export * from "./TermsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports